"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const erdjs_auth_1 = require("@elrond-giants/erdjs-auth");
class ProviderBuilder {
    constructor(env, projectId = null, webConnectionOptions = {}) {
        this.env = env;
        this.projectId = projectId;
        this.webConnectionOptions = webConnectionOptions;
    }
    buildProvider(type) {
        let providerName = type.toLowerCase()
            .split("_")
            .map(s => s.charAt(0).toUpperCase() + s.slice(1))
            .join("");
        const method = `build${providerName}Provider`;
        // @ts-ignore
        if (typeof this[method] === "function") {
            // @ts-ignore
            return this[method]();
        }
        throw new Error(`There is no auth provider called ${providerName}`);
    }
    buildWalletConnectProvider() {
        if (!this.projectId) {
            throw new Error("Project ID is required for Wallet Connect.");
        }
        return new erdjs_auth_1.WalletConnectProviderFactory(this.env, this.projectId).createProvider();
    }
    buildWebwalletProvider() {
        return new erdjs_auth_1.WebProviderFactory(this.env)
            .setConnectionOptions(this.webConnectionOptions)
            .createProvider();
    }
    buildExtensionProvider() {
        return new erdjs_auth_1.ExtensionProviderFactory().createProvider();
    }
    buildLedgerProvider() {
        return new erdjs_auth_1.LedgerProviderFactory().createProvider();
    }
    buildMaiarProvider() {
        return this.buildWalletConnectProvider();
    }
    buildWebviewProvider() {
        return new erdjs_auth_1.WebviewProviderFactory().createProvider();
    }
}
exports.default = ProviderBuilder;
;
